// extracted by mini-css-extract-plugin
module.exports =  {"content-base":"p7i338h","contentBase":"p7i338h"};